var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useState, useRef, useEffect } from 'react';
import { Text } from '../../../../../atoms/Text/Text';
import orchestratorApiClient from '../../../../../../features/AIChatWidget/services/orchestrator-api-client';
import './SearchFieldStyles.scss';
const baseClass = 'qmb-ui-search-field';
export function SearchField({ name, label, searchEndpoint, value, displayLabel, onChange, placeholder = 'Search...', disabled = false, error, required = false }) {
    const [query, setQuery] = useState(displayLabel || '');
    const [results, setResults] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const containerRef = useRef(null);
    useEffect(() => {
        setQuery(displayLabel || '');
    }, [displayLabel]);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleSearch = (searchQuery) => __awaiter(this, void 0, void 0, function* () {
        setQuery(searchQuery);
        if (!searchQuery.trim()) {
            setResults([]);
            setIsOpen(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = yield orchestratorApiClient.get(searchEndpoint, {
                params: { q: searchQuery }
            });
            const data = response.data;
            setResults(Array.isArray(data) ? data : []);
            setIsOpen(true);
        }
        catch (err) {
            console.error('[SearchField] Search error:', err);
            setResults([]);
        }
        finally {
            setIsLoading(false);
        }
    });
    const handleSelect = (option) => {
        onChange(option.value, option.label);
        setQuery(option.label);
        setIsOpen(false);
    };
    return (React.createElement("div", { className: baseClass, ref: containerRef },
        React.createElement("label", { className: `${baseClass}__label`, htmlFor: `search-${name}` },
            React.createElement(Text, { variant: "x-small" },
                label,
                required && ' *')),
        React.createElement("div", { className: `${baseClass}__input-wrapper` },
            React.createElement("input", { id: `search-${name}`, type: "text", className: `${baseClass}__input ${error ? `${baseClass}__input--error` : ''}`, value: query, onChange: (e) => {
                    void handleSearch(e.target.value);
                }, placeholder: placeholder, disabled: disabled, "aria-label": label, autoComplete: "off" }),
            isLoading && React.createElement("i", { className: `${baseClass}__spinner fa-light fa-spinner-third fa-spin`, "aria-hidden": "true" })),
        isOpen && results.length > 0 && (React.createElement("ul", { className: `${baseClass}__results`, role: "listbox" }, results.map((option) => (React.createElement("li", { key: option.value, role: "option", "aria-selected": option.value === value },
            React.createElement("button", { type: "button", className: `${baseClass}__result-item`, onClick: () => handleSelect(option) },
                React.createElement(Text, { variant: "body" }, option.label))))))),
        error && (React.createElement(Text, { variant: "xx-small", className: `${baseClass}__error` }, error))));
}
